<template>
  <div class="container-fluid bg3">
    <!-- 控制区 -->
    <audio ref="marioJump" :src="successSound" preload="auto"></audio>
    <img src="@/assets/images/title.png" alt="英语排雷挑战赛" class="title-image" />

    <div class="control-panel mb-3">
      <div>
        <!-- 文件输入隐藏，由按钮触发 -->
        <input
          type="file"
          ref="fileInput"
          accept=".xlsx"
          @change="onFileChange"
          style="display: none"
        />
        <div class="control-section">
          <button class="file-input-label filgreen me-2" @click="triggerFileInput">
            导入数据
          </button>
        </div>
        <div class="control-section">
          <button class="file-input-label filgreen me-2" @click="downloadTemplate">
            下载模板
          </button>
        </div>
        <div class="control-section">
          <button class="file-input-label filred me-2" @click="confirmClear">
            清除数据
          </button>
        </div>
        <div class="control-section">
          <button class="file-input-label filred me-2" @click="showTotalModal = true">
            查看累计成绩
          </button>
        </div>
        <div class="control-section">
          <button class="file-input-label fildark" @click="startGame">
            开始游戏
          </button>
        </div>
      </div>
    </div>

    <!-- 游戏区 -->
    <div class="row game-container mb-3">
      <!-- 玩家一 -->
      <div class="col-12 col-md-5 player-area player-areabg1">
        <div class="player-header">
          <span class="player-name">玩家一</span>
          <select v-model="selected.player1" class="form-select mb-2">
            <option value="" disabled>选择玩家</option>
            <option v-for="name in students" :key="name">{{ name }}</option>
          </select>
        </div>
        <div class="border p-3 mb-2 text-center fs-4 current-word">
          {{ currentWord }}
        </div>
        <div class="row row-cols-4 definitions-grid g-2">
          <div class="col" v-for="(card, idx) in cards" :key="`p1-${idx}`">
            <button
              class="definition-card"
              :class="`btn-${card.variant1}`"
              @click="onCardClick(card, 'player1')"
            >
              {{ card.text }}
            </button>
          </div>
        </div>
        <p class="fenshu mt-2">分数: {{ scores.player1 }}</p>
      </div>

      <!-- 玩家二 -->
      <div class="col-12 col-md-5 player-area player-areabg2">
        <div class="player-header">
          <span class="player-name">玩家二</span>
          <select v-model="selected.player2" class="form-select mb-2">
            <option value="" disabled>选择玩家</option>
            <option v-for="name in students" :key="name">{{ name }}</option>
          </select>
        </div>
        <div class="border p-3 mb-2 text-center fs-4 current-word">
          {{ currentWord }}
        </div>
        <div class="row row-cols-4 definitions-grid">
          <div class="col" v-for="(card, idx) in cards" :key="`p2-${idx}`">
            <button
              class="definition-card"
              :class="`btn-${card.variant2}`"
              @click="onCardClick(card, 'player2')"
            >
              {{ card.text }}
            </button>
          </div>
        </div>
        <p class="fenshu mt-2">分数: {{ scores.player2 }}</p>
      </div>
    </div>

    <!-- 本局排名 -->
    <div v-if="finished" class="mt-5 bg-light p-3 rounded">
      <h4>本局排名</h4>
      <ul class="list-group">
        <li
          v-for="(p, i) in ranking"
          :key="i"
          class="list-group-item d-flex justify-content-between"
        >
          <span>{{ i + 1 }}. {{ p.name }}</span>
          <span>{{ p.score }} 分</span>
        </li>
      </ul>
    </div>

    <!-- 累计成绩 Modal -->
    <div v-if="showTotalModal">
      <div class="modal fade show" tabindex="-1" style="display: block; background: rgba(0, 0, 0, 0.5)">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header d-flex justify-content-between align-items-center">
              <h5 class="modal-title mb-0">累计成绩排行</h5>
              <button type="button" class="btn-close rounded-circle" aria-label="Close" @click="showTotalModal = false"></button>
            </div>
            <div class="modal-body">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>姓名</th>
                    <th>累计积分</th>
                    <th>获胜次数</th>
                    <th>胜率</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(p, i) in totalRanking" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>{{ p.name }}</td>
                    <td>{{ p.score }}</td>
                    <td>{{ p.win }}</td>
                    <td>{{ p.rate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade show" @click="showTotalModal = false"></div>
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import successSound from "@/assets/sounds/success.mp3";

export default {
  name: "Game",
  data() {
    return {
      students: [],
      words: [],
      gameIndices: [],
      currentRound: 0,
      MAX_ROUNDS: 16,
      cards: [],
      currentWord: "",
      correctAnswer: "",
      scores: { player1: 0, player2: 0 },
      finished: false,
      showTotalModal: false,
      successSound,
      selected: { player1: "", player2: "" },
      // —— 新增：作为触发 totalRanking 刷新的响应式 key
      totalKey: 0,
    };
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (evt) => {
        const wb = XLSX.read(new Uint8Array(evt.target.result), { type: "array" });
        const rows = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
        this.students = [];
        this.words = [];
        rows.forEach((r) => {
          const name = r["姓名"] || r["name"];
          const eng = r["英文"] || r["English"];
          const chi = r["中文"] || r["Chinese"];
          if (name && !this.students.includes(name)) this.students.push(name);
          if (eng && chi) this.words.push({ eng, chi });
        });
        alert(`已导入 ${this.students.length} 名学生，${this.words.length} 个单词`);
      };
      reader.readAsArrayBuffer(file);
    },
    downloadTemplate() {
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet([["姓名", "英文", "中文"]]);
      XLSX.utils.book_append_sheet(wb, ws, "模板");
      XLSX.writeFile(wb, "模板.xlsx");
    },
    confirmClear() {
      if (confirm("确定要清除所有存储的学生和单词数据吗?")) {
        this.students = [];
        this.words = [];
        this.gameIndices = [];
        this.currentRound = 0;
        this.cards = [];
        this.scores = { player1: 0, player2: 0 };
        this.finished = false;
      }
    },
    startGame() {
      if (!this.words.length || !this.selected.player1 || !this.selected.player2) {
        alert("请先导入数据并选择玩家");
        return;
      }
      // 打乱并截取前 N
      const allIdx = this.words.map((_, i) => i);
      for (let i = allIdx.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [allIdx[i], allIdx[j]] = [allIdx[j], allIdx[i]];
      }
      this.gameIndices = allIdx.slice(0, Math.min(this.MAX_ROUNDS, allIdx.length));
      this.currentRound = 0;
      this.scores = { player1: 0, player2: 0 };
      this.finished = false;
      this.$refs.marioJump.play().catch(() => {});
      this.nextRound();
    },
    nextRound() {
      if (this.currentRound >= this.gameIndices.length) {
        this.endGame();
        return;
      }
      const idx = this.gameIndices[this.currentRound++];
      const { eng, chi } = this.words[idx];
      this.currentWord = eng;
      this.correctAnswer = chi;
      this.generateCards();
    },
    generateCards() {
      const MAX_CARDS = 12;
      const allChis = this.words.map((w) => w.chi);
      const set = new Set([this.correctAnswer]);
      while (set.size < Math.min(MAX_CARDS, allChis.length)) {
        set.add(allChis[Math.floor(Math.random() * allChis.length)]);
      }
      this.cards = Array.from(set)
        .sort(() => Math.random() - 0.5)
        .map((text) => ({
          text,
          variant1: "outline-secondary",
          variant2: "outline-secondary",
        }));
    },
    onCardClick(card, playerKey) {
      if (this.finished) return;
      const prop = playerKey === "player1" ? "variant1" : "variant2";
      if (card.text === this.correctAnswer) {
        this.scores[playerKey]++;
        card[prop] = "success";
        this.$refs.marioJump.currentTime = 0;
        this.$refs.marioJump.play();
        setTimeout(() => this.nextRound(), 600);
      } else {
        this.scores[playerKey]--;
        card[prop] = "danger";
        setTimeout(() => {
          card.variant1 = card.variant2 = "outline-secondary";
        }, 500);
      }
    },
    endGame() {
      this.finished = true;

      // 1. 读取或初始化累计数据
      const ts = JSON.parse(localStorage.getItem("totalScores") || "{}");
      const tw = JSON.parse(localStorage.getItem("totalWins")   || "{}");
      const tp = JSON.parse(localStorage.getItem("totalPlays")  || "{}");

      const { player1: p1, player2: p2 } = this.selected;
      const { player1: s1, player2: s2 } = this.scores;

      // 2. 更新累计积分和场次
      ts[p1] = (ts[p1] || 0) + s1;
      ts[p2] = (ts[p2] || 0) + s2;
      tp[p1] = (tp[p1] || 0) + 1;
      tp[p2] = (tp[p2] || 0) + 1;

      // 3. 更新胜利次数
      if (s1 > s2) {
        tw[p1] = (tw[p1] || 0) + 1;
      } else if (s2 > s1) {
        tw[p2] = (tw[p2] || 0) + 1;
      }

      // 4. 写回 localStorage
      localStorage.setItem("totalScores", JSON.stringify(ts));
      localStorage.setItem("totalWins",   JSON.stringify(tw));
      localStorage.setItem("totalPlays",  JSON.stringify(tp));

      // 5. 触发 totalRanking 重新计算
      this.totalKey++;
    },
  },
  computed: {
    ranking() {
      return [
        { name: this.selected.player1, score: this.scores.player1 },
        { name: this.selected.player2, score: this.scores.player2 },
      ].sort((a, b) => b.score - a.score);
    },
    totalRanking() {
      // 引用 totalKey，使之成为响应式依赖
      const _ = this.totalKey;

      const ts = JSON.parse(localStorage.getItem("totalScores") || "{}");
      const tw = JSON.parse(localStorage.getItem("totalWins")   || "{}");
      const tp = JSON.parse(localStorage.getItem("totalPlays")  || "{}");

      return Object.keys(ts)
        .map((n) => ({
          name: n,
          score: ts[n] || 0,
          win:   tw[n] || 0,
          rate:  (((tw[n] || 0) / (tp[n] || 1)) * 100).toFixed(1) + "%",
        }))
        .sort((a, b) => b.score - a.score);
    },
  },
};
</script>

  <style scoped>
:root {
  --primary-color: #ff6b6b;
  --secondary-color: #4ecdc4;
  --accent-color: #ffe66d;
  --dark-color: #292f36;
  --light-color: #f7fff7;
}

.bg3 {
  font-family: "Comic Neue", cursive;

  margin: 0 auto;
  padding-left: 10%;
  padding-right: 10%;
  background-color: #f7fff7;
  background-image: url("@/assets/images/pkbg.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  min-height: 100vh;
  position: relative;
}

.title-image {
  display: block;
  margin: 0 auto 20px;
  max-width: 100%;
  height: auto;
}

.control-panel {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 20px;
  flex-wrap: nowrap !important;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 15px;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border: 4px dashed #f0c905;
  margin-right: 80px; /* 右外边距 */
  margin-left: 80px; /* 左外边距 */
}

.control-section {
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
}

.control-panel .control-section button {
  background-color: var(--primary-color);
}

button,
.file-input-label {
  padding: 10px 15px;
  background-color: var(--primary-color) !important;
  color: rgb(255, 255, 255);
  border: none;
  border-radius: 50px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  font-family: "Comic Neue", cursive;
  font-weight: bold;
  box-shadow: 0 4px 0 rgba(0, 0, 0, 0.1);
  white-space: nowrap;
  margin: 2px;
  width: 100%;
  text-align: center;
}

.file-input-label {
  background-color: var(--secondary-color);
}
.filgreen {
  background-color: #4ecdc4 !important;
}
.filred {
  background-color: #ff6b6b !important;
}
.fildark {
  background-color: #292f36 !important;
}

button:hover,
.file-input-label:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 0 rgba(0, 0, 0, 0.1);
}

button:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 4px 0 rgba(0, 0, 0, 0.1);
}

.game-container {
  display: flex;
  justify-content: space-between;
  gap: 25px;
  margin-bottom: 20px;
  height: calc(100vh - 280px);
  min-height: 500px;
}

.player-area {
  flex: 1;
  min-width: 450px;

  background-color: rgba(247, 255, 247, 0.3); /* 调整背景颜色的透明度 */
  background-size: cover;
  background-position: center;
  border-radius: 15px;
  padding: 15px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  border: 3px solid var(--accent-color);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  border: 4px solid #ffde00; /* 添加黄色边框 */
  border-radius: 15px; /* 可选：添加圆角 */
}
.player-areabg1 {
  background-image: url("@/assets/images/game-bg1.png");
}

.player-areabg2 {
  background-image: url("@/assets/images/game-bg2.png");
}
.player-header {
  display: flex;
  align-items: stretch; /* 使子元素在垂直方向拉伸至相同高度 */
  justify-content: center;
  gap: 10px; /* 两者之间的间距 */
  /* margin-bottom: 15px; */
  display: flex; /* 让其内部内容垂直居中，配合 align-items: stretch */
  align-items: center;
  justify-content: center;
}
/* 2. 给玩家名字加上圆形黄色背景 */
.player-header .player-name {
  background-color: var(--accent-color); /* 黄色 */
  padding: 8px 16px;
  border-radius: 50px; /* 圆角 */
}
.player-name {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: auto;
  color: #292f36;
  display: inline-block;
  background-color: #ffe66d !important;
  /* padding: 5px 5px; */
  border-radius: 50px;
  border: 3px solid white;
  box-shadow: 0 3px 0 rgba(0, 0, 0, 0.1);
  z-index: 2;

  display: flex; /* 让其内部内容垂直居中，配合 align-items: stretch */
  align-items: center;
  justify-content: center;
}

.player-header ::v-deep .form-select {
  /* 清除 Bootstrap 的 background-image */
  background-image: none !important;
  width: auto; /* 取消默认 100% 宽度 */
  min-width: 80px; /* 最小宽度，可根据需要调小或调大 */
  max-width: 130px; /* 最大宽度 */
  padding: 0.25rem 0.75rem; /* 调整内边距以配合高度 */

  color: #292f36 !important; /* 直接使用深色值 */

  /* 设置你的半透明黄色 */
  background-color: rgba(255, 230, 109, 0.5) !important;
  border-radius: 50px;

  /* 去掉系统外观 */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
/* 
.player-header .form-select:focus {
  box-shadow: none;
  outline: none;
} */
.current-word {
  font-size: 46px !important;
  font-weight: bold;
  text-align: center;
  min-height: 34px;
  margin: 15px 0;
  padding: 10px;
  background-color: rgba(255, 230, 109) !important;
  border-radius: 10px;
  font-family: "Fredoka One", cursive;
  color: var(--dark-color) !important;
  border: 3px solid white;
  z-index: 2;
}

.definitions-grid {
  display: flex !important; /* 改成 flex */
  flex-wrap: wrap; /* 多行显示 */
  justify-content: center; /* 水平居中，如果需要 */
  align-items: center; /* 垂直居中 */

  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  flex-grow: 1;
  overflow: hidden;
  z-index: 2;
}
/* 
.definitions-grid button {
  min-width:100px;
  border-width: 30px !important; 
  border-color: gray; 
  background-color: #ccc !important; 
  font-size: 30px !important; 
  color: #050505;
} */

.definition-card {
  min-height: 100px;
  min-width: 150px; /* 原来可能是 70px，这里改成 100px */
  padding: 20px; /* 增加内边距 */
  font-size: 30px;
  color: #000;
  background-color: rgba(255, 255, 255, 0.9) !important;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border: 2px solid #ffe66d !important;
  word-break: break-word;
  overflow: hidden;
  position: relative;
}
.definition-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
}

.definition-card.correct::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("@/assets/images/right.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 3;
}

.boom-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("@/assets/images/boom.png");
  background-size: cover;
  background-position: center;
  opacity: 0.4;
  z-index: 10;
  pointer-events: none;
}

select {
  padding: 8px 12px;
  border-radius: 50px;
  border: 2px solid var(--secondary-color);
  font-family: "Comic Neue", cursive;
  font-size: 18px;
  color: #292f36 !important; /* 直接使用深色值 */
  background-color: white !important;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
  margin-left: 5px;
  min-width: 50px;
  z-index: 100;
}
.player-header ::v-deep .form-select option {
  background-color: #ffffff !important;
  color: #050505 !important;
}
.file-input {
  display: none;
}

.storage-info {
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
  color: var(--dark-color);
  background-color: rgba(255, 255, 255, 0.8);
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.winner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(
    135deg,
    var(--primary-color),
    var(--secondary-color)
  );
  color: white;
  padding: 30px;
  border-radius: 15px;
  text-align: center;
  font-size: 24px;
  z-index: 100;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  font-family: "Fredoka One", cursive;
  cursor: pointer;
}

.music-control {
  display: flex;
  align-items: center;
  gap: 10px;
}

.music-toggle {
  width: 40px;
  height: 40px;
  background-color: var(--secondary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 2px solid white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.fenshu {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 90px;
  border: 2px solid #ffe66d !important;
  font-size: 20px;
  background-color: #f7fff7;
  border-radius: 15px;
}
.music-toggle i {
  color: white;
  font-size: 20px;
}

/* 成功／失败状态的高优先级覆盖 */
.player-area ::v-deep .definition-card.btn-success {
  background-color: #d4edda !important;
  border-color: #c3e6cb !important;
  color: #155724 !important;
}

.player-area ::v-deep .definition-card.btn-danger {
  background-color: #f8d7da !important;
  border-color: #f5c6cb !important;
  color: #721c24 !important;
}

.modal-header .btn-close {
  width: 32px;
  height: 32px;
  padding: 0.25rem; /* 图标内边距保持可点面积 */
  border-radius: 50%; /* 完全圆形 */
  background-color: rgba(0, 0, 0, 0.1); /* 半透明背景，更好点击 */
  border: none;
}

/* 鼠标悬停时加深背景 */
.modal-header .btn-close:hover {
  background-color: rgba(0, 0, 0, 0.2);
}

@media (max-width: 575.98px) {
  .control-panel {
    flex-wrap: wrap;
    padding: 10px;
  }
  .control-section { flex: 1 1 100%; margin-bottom: 10px; }
  .current-word {
    font-size: 28px !important;
    padding: 8px;
  }
  .definition-card {
    min-width: 100px;
    min-height: 80px;
    font-size: 20px;
    padding: 10px;
  }
  .fenshu {
    width: 100%;
    font-size: 18px;
  }
}
@media (max-width: 575.98px) {
  .player-area {
    min-width: 0;    /* 允许比 450px 更窄 */
    width: 100%;     /* 宽度撑满父容器 */
    margin-bottom: 15px; /* 两个区域垂直堆叠时保持间距 */
  }
}
</style>
  